import React, { FC, ReactNode, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';

import './ad-slot-placeholder-gam.scss';

interface AdSlotPlaceholderGAMProps {
    children: ReactNode;
    className?: string;
    isHideAdText?: boolean;
}

const AdSlotPlaceholderGAM: FC<AdSlotPlaceholderGAMProps> = ({ className, children, isHideAdText }) => {
    const ref = useRef<HTMLDivElement>(null);
    const [isShowAdText, setIsShowAdText] = useState(true);

    useEffect(() => {
        let observerRef: HTMLDivElement | null = null;

        const observe = (entries: ResizeObserverEntry[]): void => {
            setIsShowAdText(!entries[0].contentRect.height);
        };

        const resizeObserver = new ResizeObserver(observe);

        if (!isHideAdText && ref.current) {
            resizeObserver.observe(ref.current);
            observerRef = ref.current;
        }

        return () => {
            if (!isHideAdText && observerRef) {
                resizeObserver.unobserve(observerRef);
            }
        };
    }, [isHideAdText]);

    return (
        <div className={classNames('ad-slot-placeholder-gam', className)}>
            {!isHideAdText && isShowAdText && (
                <p className="ad-slot-placeholder-gam__text">
                    REKLAMA
                </p>
            )}
            <div
                className="ad-slot-placeholder-gam__wrapper"
                ref={ref}
            >
                {children}
            </div>
        </div>
    );
};

export default AdSlotPlaceholderGAM;
